var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2445 14.4862V8.1543L19.5247 9.62649L19.2834 14.1268L18.2445 14.4862Z",
    fill: "url(#paint0_linear_34462_38254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26904 16.584V20.0158L11.854 20.9119L14.4439 20.0158V16.584H9.26904Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5495 16.584V19.8139L11.8538 20.6165L14.163 19.8139V16.584H9.5495Z",
    fill: "url(#paint1_radial_34462_38254)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4434 16.584V20.0158L14.7241 20.2128V16.584H14.4434Z",
    fill: "url(#paint2_linear_34462_38254)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4436 20.0158V16.584H14.163V19.8139L14.4436 20.0158Z",
    fill: "url(#paint3_linear_34462_38254)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54969 19.8139V16.584H9.26904V20.0158L9.54969 19.8139Z",
    fill: "url(#paint4_linear_34462_38254)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26948 20.0158V16.584H8.98883V20.2128L9.26948 20.0158Z",
    fill: "url(#paint5_linear_34462_38254)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95388 20.252L11.8544 20.9117V21.2072L9.95388 20.5474L8.98883 20.2126L9.26948 20.0156L9.95388 20.252Z",
    fill: "url(#paint6_linear_34462_38254)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.854 20.9115L9.95344 20.2517L9.26904 20.0153L9.54969 19.8135L9.95344 19.9563L11.854 20.616V20.9115Z",
    fill: "url(#paint7_linear_34462_38254)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8542 20.9117L13.7597 20.252L14.4441 20.0156L14.7248 20.2126L13.7597 20.5474L11.8542 21.2072V20.9117Z",
    fill: "url(#paint8_linear_34462_38254)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4441 20.0153L13.7597 20.2517L11.8542 20.9115V20.616L13.7597 19.9563L14.1635 19.8135L14.4441 20.0153Z",
    fill: "url(#paint9_linear_34462_38254)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46767 14.4862V8.1543L4.1875 9.62649L4.42876 14.1268L5.46767 14.4862Z",
    fill: "url(#paint10_linear_34462_38254)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46796 11.5571L5.71906 11.3848L11.854 13.5069V13.7728L5.46796 11.5571Z",
    fill: "url(#paint11_linear_34462_38254)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2452 11.5571L17.9892 11.3848L11.8542 13.5069V13.7728L18.2452 11.5571Z",
    fill: "url(#paint12_linear_34462_38254)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46796 2.36914L5.71906 2.61533V11.3845L5.46796 11.5568V2.36914Z",
    fill: "url(#paint13_linear_34462_38254)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8534 20.0252V13.7721L5.4674 11.5564L5.21136 11.4678V17.716L11.8534 20.0252Z",
    fill: "url(#paint14_linear_34462_38254)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8542 13.7721V20.0252L18.5013 17.716V11.4678L18.2452 11.5564L11.8542 13.7721Z",
    fill: "url(#paint15_linear_34462_38254)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8534 19.7547L5.4674 17.5391L5.21136 17.7163L11.8534 20.0255V19.7547Z",
    fill: "url(#paint16_linear_34462_38254)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2452 17.5391L11.8542 19.7547V20.0255L18.5013 17.7163L18.2452 17.5391Z",
    fill: "url(#paint17_linear_34462_38254)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21163 2.17676V8.93701L4.1875 9.62633L4.42876 14.1266L5.21163 14.3974V17.716L5.46767 17.5387V14.486V11.6254V8.76468V2.36878L5.21163 2.17676Z",
    fill: "url(#paint18_linear_34462_38254)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2298 10.5969L18.57 10.2129V13.1179L19.1116 12.8028L19.2298 10.5969Z",
    fill: "#808080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71887 2.61487V11.3741L11.8538 13.5061L17.9888 11.3741V2.61487L11.8538 1.71875L5.71887 2.61487Z",
    fill: "url(#paint19_radial_34462_38254)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04279 12.1866L16.6593 2.42285L17.9887 2.61488V11.384L11.8537 13.5061L8.04279 12.1866Z",
    fill: "url(#paint20_radial_34462_38254)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62471 3.39779V4.95861L6.39822 4.73212V3.20084L11.8586 2.4032L15.3889 2.92019V3.14668L11.8586 2.62969L6.62471 3.39287V3.39779ZM6.62471 5.12109V7.96207L6.28497 8.30181V10.9803L11.8537 12.9153L17.4224 10.9803V6.48988L17.4126 6.48003L17.3092 6.37664L17.0827 6.15015V3.40272L15.4923 3.1713V2.83157L11.8537 2.2998L6.28497 3.11222V4.78628L6.62471 5.12601V5.12109ZM6.62471 8.11963V10.7341L10.5341 12.0931V12.3343L6.39822 10.8966V8.34612L6.62471 8.11963ZM10.6474 12.1325L11.8586 12.551L13.0698 12.1325V12.3737L11.8586 12.7922L10.6474 12.3737V12.1325ZM13.1782 12.0931L17.0876 10.7341V6.3077L17.3141 6.5342V10.8966L13.1782 12.3343V12.0931ZM6.73795 3.49627V10.6553L11.8586 12.4328L16.9793 10.6553V3.49627L11.8586 2.74786L6.73795 3.49627Z",
    fill: "url(#paint21_radial_34462_38254)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4674 2.36903L11.8534 1.46306V1.20703L5.21136 2.177L5.4674 2.36903Z",
    fill: "url(#paint22_linear_34462_38254)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.854 1.46289L5.46796 2.36885L5.71906 2.61504L11.854 1.71892V1.46289Z",
    fill: "url(#paint23_linear_34462_38254)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2452 2.36914L17.9892 2.61533V11.3845L18.2452 11.5568V2.36914Z",
    fill: "url(#paint24_linear_34462_38254)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2452 2.36903L11.8542 1.46306V1.20703L18.5013 2.177L18.2452 2.36903Z",
    fill: "url(#paint25_linear_34462_38254)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8542 1.46289L18.2452 2.36885L17.9892 2.61504L11.8542 1.71892V1.46289Z",
    fill: "url(#paint26_linear_34462_38254)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4269 6.3229V3.10279L15.61 2.83691V3.06833L17.2004 3.29974V6.10133L17.4269 6.3229Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28497 4.93945V8.13986L6.51146 7.90845V5.16594L6.28497 4.93945Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8533 12.5514L10.647 12.1279V12.3692L11.8533 12.7877L13.0645 12.3692V12.1279L11.8533 12.5514Z",
    fill: "url(#paint27_radial_34462_38254)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8535 15.003L11.7353 13.8607L6.56543 11.9404L11.8535 13.772V15.003Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46691 7.49421L5.37336 2.40309L5.24042 2.20122L5.48168 2.29477L7.51517 2.07812L5.46691 2.36862V7.49421Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.245 1.97497L11.7901 1.38412L11.8541 1.22656V1.4629L8.245 1.97497Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0496 17.2435H16.6842V16.7511H15.5764V14.8407H15.0496V17.2435ZM13.085 17.2435H14.7541V16.7511H13.6118V16.2342H14.6114V15.7418H13.6118V15.3282H14.7541V14.8358H13.085V17.2386V17.2435ZM12.115 17.2435L12.8782 14.9343V14.7324L12.3957 14.7718L11.9033 16.2489L11.859 16.5H11.8442L11.7999 16.2489L11.3076 14.7718L10.825 14.7324V14.9343L11.5882 17.2435H12.1101H12.115ZM8.95894 17.2435H10.6281V16.7511H9.48578V16.2342H10.4853V15.7418H9.48578V15.3282H10.6281V14.8358H8.95894V17.2386V17.2435ZM7.02393 17.2435H8.6586V16.7511H7.55076V14.8407H7.02393V17.2435Z",
    fill: "#4D5E6E"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0496 17.042H16.6842V16.5496H15.5764V14.6392H15.0496V17.042ZM13.085 17.042H14.7541V16.5496H13.6118V16.0327H14.6114V15.5403H13.6118V15.1267H14.7541V14.6343H13.085V17.0371V17.042ZM12.115 17.042L12.8782 14.7328L12.3957 14.5703L11.9033 16.0474L11.859 16.2985H11.8442L11.7999 16.0474L11.3076 14.5703L10.825 14.7328L11.5882 17.042H12.1101H12.115ZM8.95894 17.042H10.6281V16.5496H9.48578V16.0327H10.4853V15.5403H9.48578V15.1267H10.6281V14.6343H8.95894V17.0371V17.042ZM7.02393 17.042H8.6586V16.5496H7.55076V14.6392H7.02393V17.042Z",
    fill: "url(#paint28_linear_34462_38254)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87054 15.2197V15.2542C5.87054 15.3231 5.92471 15.3773 5.99364 15.3773H6.28906C6.35799 15.3773 6.41215 15.3231 6.41215 15.2542V15.2197H5.87054Z",
    fill: "url(#paint29_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30037 15.1211H5.98525C5.95079 15.1211 5.91632 15.1506 5.91632 15.19C5.91632 15.2245 5.94586 15.259 5.98525 15.259H6.30037C6.33484 15.259 6.3693 15.2294 6.3693 15.19C6.3693 15.1556 6.33976 15.1211 6.30037 15.1211Z",
    fill: "url(#paint30_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87054 15.8457V15.8802C5.87054 15.9491 5.92471 16.0033 5.99364 16.0033H6.28906C6.35799 16.0033 6.41215 15.9491 6.41215 15.8802V15.8457H5.87054Z",
    fill: "url(#paint31_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30037 15.7422H5.98525C5.95079 15.7422 5.91632 15.7717 5.91632 15.8111C5.91632 15.8456 5.94586 15.8801 5.98525 15.8801H6.30037C6.33484 15.8801 6.3693 15.8505 6.3693 15.8111C6.3693 15.7767 6.33976 15.7422 6.30037 15.7422Z",
    fill: "url(#paint32_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87054 16.4561V16.4905C5.87054 16.5595 5.92471 16.6136 5.99364 16.6136H6.28906C6.35799 16.6136 6.41215 16.5595 6.41215 16.4905V16.4561H5.87054Z",
    fill: "url(#paint33_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30037 16.3574H5.98525C5.95079 16.3574 5.91632 16.387 5.91632 16.4264C5.91632 16.4608 5.94586 16.4953 5.98525 16.4953H6.30037C6.33484 16.4953 6.3693 16.4657 6.3693 16.4264C6.3693 16.3919 6.33976 16.3574 6.30037 16.3574Z",
    fill: "url(#paint34_linear_34462_38254)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29309 15.0967H5.99767C5.92873 15.0967 5.87457 15.1508 5.87457 15.2198C5.87457 15.2887 5.92873 15.3429 5.99767 15.3429H6.29309C6.36202 15.3429 6.41618 15.2887 6.41618 15.2198C6.41618 15.1508 6.36202 15.0967 6.29309 15.0967Z",
    fill: "url(#paint35_linear_34462_38254)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29449 15.7217H5.99907C5.93014 15.7217 5.87598 15.7758 5.87598 15.8448C5.87598 15.9137 5.93014 15.9679 5.99907 15.9679H6.29449C6.36343 15.9679 6.41759 15.9137 6.41759 15.8448C6.41759 15.7758 6.36343 15.7217 6.29449 15.7217Z",
    fill: "url(#paint36_linear_34462_38254)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29449 16.3379H5.99907C5.93014 16.3379 5.87598 16.3921 5.87598 16.461C5.87598 16.5299 5.93014 16.5841 5.99907 16.5841H6.29449C6.36343 16.5841 6.41759 16.5299 6.41759 16.461C6.41759 16.3921 6.36343 16.3379 6.29449 16.3379Z",
    fill: "url(#paint37_linear_34462_38254)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2947 15.2197V15.2542C17.2947 15.3231 17.3489 15.3773 17.4178 15.3773H17.7133C17.7822 15.3773 17.8363 15.3231 17.8363 15.2542V15.2197H17.2947Z",
    fill: "url(#paint38_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7231 15.1211H17.408C17.3735 15.1211 17.3391 15.1506 17.3391 15.19C17.3391 15.2245 17.3686 15.259 17.408 15.259H17.7231C17.7576 15.259 17.792 15.2294 17.792 15.19C17.792 15.1556 17.7625 15.1211 17.7231 15.1211Z",
    fill: "url(#paint39_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2947 15.8457V15.8802C17.2947 15.9491 17.3489 16.0033 17.4178 16.0033H17.7133C17.7822 16.0033 17.8363 15.9491 17.8363 15.8802V15.8457H17.2947Z",
    fill: "url(#paint40_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7231 15.7422H17.408C17.3735 15.7422 17.3391 15.7717 17.3391 15.8111C17.3391 15.8456 17.3686 15.8801 17.408 15.8801H17.7231C17.7576 15.8801 17.792 15.8505 17.792 15.8111C17.792 15.7767 17.7625 15.7422 17.7231 15.7422Z",
    fill: "url(#paint41_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2947 16.4561V16.4905C17.2947 16.5595 17.3489 16.6136 17.4178 16.6136H17.7133C17.7822 16.6136 17.8363 16.5595 17.8363 16.4905V16.4561H17.2947Z",
    fill: "url(#paint42_linear_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7231 16.3574H17.408C17.3735 16.3574 17.3391 16.387 17.3391 16.4264C17.3391 16.4608 17.3686 16.4953 17.408 16.4953H17.7231C17.7576 16.4953 17.792 16.4657 17.792 16.4264C17.792 16.3919 17.7625 16.3574 17.7231 16.3574Z",
    fill: "url(#paint43_linear_34462_38254)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7131 15.0967H17.4176C17.3487 15.0967 17.2946 15.1508 17.2946 15.2198C17.2946 15.2887 17.3487 15.3429 17.4176 15.3429H17.7131C17.782 15.3429 17.8362 15.2887 17.8362 15.2198C17.8362 15.1508 17.782 15.0967 17.7131 15.0967Z",
    fill: "url(#paint44_linear_34462_38254)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7133 15.7217H17.4178C17.3489 15.7217 17.2947 15.7758 17.2947 15.8448C17.2947 15.9137 17.3489 15.9679 17.4178 15.9679H17.7133C17.7822 15.9679 17.8363 15.9137 17.8363 15.8448C17.8363 15.7758 17.7822 15.7217 17.7133 15.7217Z",
    fill: "url(#paint45_linear_34462_38254)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7133 16.3379H17.4178C17.3489 16.3379 17.2947 16.3921 17.2947 16.461C17.2947 16.5299 17.3489 16.5841 17.4178 16.5841H17.7133C17.7822 16.5841 17.8363 16.5299 17.8363 16.461C17.8363 16.3921 17.7822 16.3379 17.7133 16.3379Z",
    fill: "url(#paint46_linear_34462_38254)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M6.2849 8.19846C6.45078 8.19846 6.58525 7.45557 6.58525 6.53917C6.58525 5.62277 6.45078 4.87988 6.2849 4.87988C6.11903 4.87988 5.98456 5.62277 5.98456 6.53917C5.98456 7.45557 6.11903 8.19846 6.2849 8.19846Z",
    fill: "url(#paint47_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46764 3.19629C5.60058 3.19629 5.7089 3.79206 5.7089 4.52569C5.7089 5.25932 5.60058 5.85509 5.46764 5.85509C5.3347 5.85509 5.22638 5.25932 5.22638 4.52569C5.22638 3.79206 5.3347 3.19629 5.46764 3.19629Z",
    fill: "url(#paint48_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M6.14179 17.071C6.47898 17.071 6.75233 16.5265 6.75233 15.8548C6.75233 15.1832 6.47898 14.6387 6.14179 14.6387C5.8046 14.6387 5.53125 15.1832 5.53125 15.8548C5.53125 16.5265 5.8046 17.071 6.14179 17.071Z",
    fill: "url(#paint49_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M17.5653 17.071C17.9025 17.071 18.1759 16.5265 18.1759 15.8548C18.1759 15.1832 17.9025 14.6387 17.5653 14.6387C17.2281 14.6387 16.9548 15.1832 16.9548 15.8548C16.9548 16.5265 17.2281 17.071 17.5653 17.071Z",
    fill: "url(#paint50_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4275 3.08301C17.5309 3.08301 17.6146 3.80679 17.6146 4.70291C17.6146 5.59902 17.5309 6.32281 17.4275 6.32281C17.3241 6.32281 17.2404 5.59902 17.2404 4.70291C17.2404 3.80679 17.3241 3.08301 17.4275 3.08301Z",
    fill: "url(#paint51_radial_34462_38254)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5247 9.62633L18.5005 8.93701V2.17676L18.2445 2.36878V8.76468V11.6254V14.486V17.5387L18.5005 17.716V14.3974L19.2834 14.1266L19.5247 9.62633Z",
    fill: "url(#paint52_linear_34462_38254)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5624 13.7724C12.5624 14.1614 12.2473 14.4765 11.8583 14.4765C11.4694 14.4765 11.1542 14.1614 11.1542 13.7724C11.1542 13.3835 11.4694 13.0684 11.8583 13.0684C12.2473 13.0684 12.5624 13.3835 12.5624 13.7724Z",
    fill: "url(#paint53_radial_34462_38254)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48254 10.5969L5.1374 10.2129V13.1179L4.60071 12.8028L4.48254 10.5969Z",
    fill: "url(#paint54_linear_34462_38254)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65088 10.6901L4.97584 10.498V12.8368L4.7592 12.7088L4.65088 10.6901Z",
    fill: "url(#paint55_radial_34462_38254)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60138 12.8025L4.75894 12.709L4.97558 12.837L5.13806 13.1177L4.60138 12.8025Z",
    fill: "url(#paint56_linear_34462_38254)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64995 10.6905L4.48254 10.5969L5.1374 10.2129L4.97491 10.4985L4.64995 10.6905Z",
    fill: "url(#paint57_linear_34462_38254)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48248 10.5967L4.64989 10.6902L4.75821 12.709L4.60065 12.8025L4.48248 10.5967Z",
    fill: "url(#paint58_linear_34462_38254)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9754 12.8372V10.4985L5.13788 10.2129V13.1179L4.9754 12.8372Z",
    fill: "url(#paint59_linear_34462_38254)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2298 10.5969L18.57 10.2129V13.1179L19.1116 12.8028L19.2298 10.5969Z",
    fill: "url(#paint60_linear_34462_38254)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0568 10.6901L18.7318 10.498V12.8368L18.9534 12.7088L19.0568 10.6901Z",
    fill: "url(#paint61_radial_34462_38254)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1116 12.8025L18.9541 12.709L18.7325 12.837L18.57 13.1177L19.1116 12.8025Z",
    fill: "url(#paint62_linear_34462_38254)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0575 10.6905L19.2298 10.5969L18.57 10.2129L18.7325 10.4985L19.0575 10.6905Z",
    fill: "url(#paint63_linear_34462_38254)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2299 10.5967L19.0576 10.6902L18.9542 12.709L19.1117 12.8025L19.2299 10.5967Z",
    fill: "url(#paint64_linear_34462_38254)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7325 12.8372V10.4985L18.57 10.2129V13.1179L18.7325 12.8372Z",
    fill: "url(#paint65_linear_34462_38254)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81277 9.21289C5.36915 9.21289 5.82213 10.3109 5.82213 11.6698C5.82213 13.0288 5.36915 14.1268 4.81277 14.1268C4.25639 14.1268 3.80341 13.0288 3.80341 11.6698C3.80341 10.3109 4.25639 9.21289 4.81277 9.21289Z",
    fill: "url(#paint66_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8998 9.21289C19.4562 9.21289 19.9092 10.3109 19.9092 11.6698C19.9092 13.0288 19.4562 14.1268 18.8998 14.1268C18.3434 14.1268 17.8904 13.0288 17.8904 11.6698C17.8904 10.3109 18.3434 9.21289 18.8998 9.21289Z",
    fill: "url(#paint67_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M4.9453 16.6621C5.06223 16.6621 5.15702 14.4246 5.15702 11.6646C5.15702 8.90448 5.06223 6.66699 4.9453 6.66699C4.82837 6.66699 4.73358 8.90448 4.73358 11.6646C4.73358 14.4246 4.82837 16.6621 4.9453 16.6621Z",
    fill: "url(#paint68_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M4.70868 9.16309C4.75792 9.16309 4.79731 10.2857 4.79731 11.6643C4.79731 13.043 4.75792 14.1656 4.70868 14.1656C4.65945 14.1656 4.62006 13.043 4.62006 11.6643C4.62006 10.2857 4.65945 9.16309 4.70868 9.16309Z",
    fill: "url(#paint69_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M18.7667 16.668C18.8849 16.668 18.9784 14.4277 18.9784 11.6704C18.9784 8.91314 18.8849 6.67285 18.7667 6.67285C18.6485 6.67285 18.555 8.91314 18.555 11.6704C18.555 14.4277 18.6485 16.668 18.7667 16.668Z",
    fill: "url(#paint70_radial_34462_38254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M19.0077 9.16406C18.9585 9.16406 18.9191 10.2867 18.9191 11.6653C18.9191 13.0439 18.9585 14.1666 19.0077 14.1666C19.0569 14.1666 19.0963 13.0439 19.0963 11.6653C19.0963 10.2867 19.0569 9.16406 19.0077 9.16406Z",
    fill: "url(#paint71_radial_34462_38254)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.367 6.56381L11.5344 6.28808L11.559 6.30285L11.4556 6.5835V9.10444H10.7318V10.1778H13.4153V9.10444H12.6915V4.52539H11.7166L10.3035 5.94342L11.1454 6.7903L11.367 6.56381Z",
    fill: "url(#paint72_linear_34462_38254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34462_38254",
    x1: 18.2445,
    y1: 11.3202,
    x2: 19.5247,
    y2: 11.3202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B3840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204954"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8538 20.6165) scale(2.41262 2.41262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B0FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9CFFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#89FFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#71FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#53FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#30FFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#08FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34462_38254",
    x1: 14.4434,
    y1: 18.3959,
    x2: 14.7241,
    y2: 18.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34462_38254",
    x1: 14.163,
    y1: 18.2974,
    x2: 14.4436,
    y2: 18.2974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34462_38254",
    x1: 9.26904,
    y1: 18.2974,
    x2: 9.54969,
    y2: 18.2974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34462_38254",
    x1: 8.98883,
    y1: 18.3959,
    x2: 9.26948,
    y2: 18.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34462_38254",
    x1: 8.98883,
    y1: 20.6114,
    x2: 11.8544,
    y2: 20.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34462_38254",
    x1: 9.26904,
    y1: 20.3649,
    x2: 11.854,
    y2: 20.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34462_38254",
    x1: 11.8542,
    y1: 20.6114,
    x2: 14.7248,
    y2: 20.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34462_38254",
    x1: 11.8542,
    y1: 20.3649,
    x2: 14.4441,
    y2: 20.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34462_38254",
    x1: 4.1875,
    y1: 11.3202,
    x2: 5.46767,
    y2: 11.3202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34462_38254",
    x1: 5.46796,
    y1: 12.5812,
    x2: 11.854,
    y2: 12.5812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34462_38254",
    x1: 11.8542,
    y1: 12.5812,
    x2: 18.2452,
    y2: 12.5812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34462_38254",
    x1: 5.46796,
    y1: 6.96296,
    x2: 5.71906,
    y2: 6.96296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_34462_38254",
    x1: 11.819,
    y1: 13.7918,
    x2: 4.78793,
    y2: 17.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A94C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_34462_38254",
    x1: 11.805,
    y1: 13.7376,
    x2: 18.7277,
    y2: 17.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42689C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_34462_38254",
    x1: 5.21136,
    y1: 18.7798,
    x2: 11.8534,
    y2: 18.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_34462_38254",
    x1: 11.8542,
    y1: 18.7798,
    x2: 18.5013,
    y2: 18.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_34462_38254",
    x1: 4.1875,
    y1: 9.94637,
    x2: 5.46767,
    y2: 9.94637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8538 1.72367) scale(11.8268 11.8268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#01429F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#033082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#042571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05226B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#091D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1C4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.46574 -0.615077) scale(15.6476 15.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.53116 3.16145) scale(15.8445 15.8445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_34462_38254",
    x1: 5.21136,
    y1: 1.78803,
    x2: 11.8534,
    y2: 1.78803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7996B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_34462_38254",
    x1: 5.46796,
    y1: 2.03896,
    x2: 11.854,
    y2: 2.03896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_34462_38254",
    x1: 17.9892,
    y1: 6.96296,
    x2: 18.2452,
    y2: 6.96296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_34462_38254",
    x1: 11.8542,
    y1: 1.78803,
    x2: 18.5013,
    y2: 1.78803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E76A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_34462_38254",
    x1: 11.8542,
    y1: 2.03896,
    x2: 18.2452,
    y2: 2.03896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8533 12.4578) scale(1.18661 1.18661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_34462_38254",
    x1: 11.8541,
    y1: 17.042,
    x2: 11.8541,
    y2: 14.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_34462_38254",
    x1: 6.14135,
    y1: 15.3773,
    x2: 6.14135,
    y2: 15.2197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_34462_38254",
    x1: 6.14281,
    y1: 15.254,
    x2: 6.14281,
    y2: 15.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_34462_38254",
    x1: 6.14135,
    y1: 15.9983,
    x2: 6.14135,
    y2: 15.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#283B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1D6073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#14809E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0D9AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#07AEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#03BCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_34462_38254",
    x1: 6.14281,
    y1: 15.8801,
    x2: 6.14281,
    y2: 15.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_34462_38254",
    x1: 6.14135,
    y1: 16.6136,
    x2: 6.14135,
    y2: 16.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_34462_38254",
    x1: 6.14281,
    y1: 16.4904,
    x2: 6.14281,
    y2: 16.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_34462_38254",
    x1: 6.14045,
    y1: 15.3429,
    x2: 6.14045,
    y2: 15.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_34462_38254",
    x1: 6.14186,
    y1: 15.9629,
    x2: 6.14186,
    y2: 15.7217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_34462_38254",
    x1: 6.14186,
    y1: 16.5792,
    x2: 6.14186,
    y2: 16.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_34462_38254",
    x1: 17.5655,
    y1: 15.3773,
    x2: 17.5655,
    y2: 15.2197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_34462_38254",
    x1: 17.5655,
    y1: 15.254,
    x2: 17.5655,
    y2: 15.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_34462_38254",
    x1: 17.5655,
    y1: 15.9983,
    x2: 17.5655,
    y2: 15.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_34462_38254",
    x1: 17.5655,
    y1: 15.8801,
    x2: 17.5655,
    y2: 15.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_34462_38254",
    x1: 17.5655,
    y1: 16.6136,
    x2: 17.5655,
    y2: 16.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_34462_38254",
    x1: 17.5655,
    y1: 16.4904,
    x2: 17.5655,
    y2: 16.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_34462_38254",
    x1: 17.5654,
    y1: 15.3429,
    x2: 17.5654,
    y2: 15.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_34462_38254",
    x1: 17.5655,
    y1: 15.9629,
    x2: 17.5655,
    y2: 15.7217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_34462_38254",
    x1: 17.5655,
    y1: 16.5792,
    x2: 17.5655,
    y2: 16.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.96388 6.6668) rotate(-90) scale(1.64373 0.273955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.21634 4.67596) rotate(-90) scale(1.31758 0.219597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.40659 15.8768) rotate(-90) scale(1.20779 0.603893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6758 15.8768) rotate(-90) scale(1.20779 0.603894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.299 4.50655) rotate(-90) scale(1.64373 0.205467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_34462_38254",
    x1: 18.2445,
    y1: 9.94637,
    x2: 19.5247,
    y2: 9.94637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8534 13.7724) scale(0.704091 0.70409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1798C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#127498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0D556F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#093B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#052530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#01090B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#000202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_34462_38254",
    x1: 4.81243,
    y1: 10.2178,
    x2: 4.81243,
    y2: 13.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.81336 11.6699) scale(0.832107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_34462_38254",
    x1: 4.86726,
    y1: 12.709,
    x2: 4.86726,
    y2: 13.1226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_34462_38254",
    x1: 4.81243,
    y1: 10.2178,
    x2: 4.81243,
    y2: 10.6905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_34462_38254",
    x1: 4.62035,
    y1: 10.6016,
    x2: 4.62035,
    y2: 12.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_34462_38254",
    x1: 5.05911,
    y1: 10.2178,
    x2: 5.05911,
    y2: 13.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_34462_38254",
    x1: 18.8999,
    y1: 10.2178,
    x2: 18.8999,
    y2: 13.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8943 11.6699) rotate(180) scale(0.832112 0.832107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_34462_38254",
    x1: 18.8408,
    y1: 12.709,
    x2: 18.8408,
    y2: 13.1226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_34462_38254",
    x1: 18.8999,
    y1: 10.2178,
    x2: 18.8999,
    y2: 10.6905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_34462_38254",
    x1: 19.092,
    y1: 10.6016,
    x2: 19.092,
    y2: 12.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_34462_38254",
    x1: 18.6537,
    y1: 10.2178,
    x2: 18.6537,
    y2: 13.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.93301 11.4843) rotate(-90) scale(2.51025 1.03363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3501 11.4843) rotate(-90) scale(2.51025 1.03363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.92598 11.7416) rotate(-90) scale(4.99471 0.203546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-20.5862 11.5462) rotate(90) scale(2.49632 0.099853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2692 11.7426) rotate(-90) scale(4.99471 0.203546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_34462_38254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7722 11.5471) rotate(90) scale(2.49632 0.099853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_34462_38254",
    x1: 13.9766,
    y1: 9.61651,
    x2: 10.3035,
    y2: 5.94342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.7441d81377f2f17661bd5d6cb4439ff2.svg";
export { ForwardRef as ReactComponent };